// Generated by purs version 0.15.15
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Group from "../Data.Group/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Ordering.eqOrdering);
var Pitch = function (x) {
    return x;
};
var Impf = function (x) {
    return x;
};
var ordPitch = function (dictOrd) {
    return dictOrd;
};
var genericPitch_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var functorPitch = {
    map: function (f) {
        return function (m) {
            return f(m);
        };
    }
};
var map1 = /* #__PURE__ */ Data_Functor.map(functorPitch);
var eqPitch = function (dictEq) {
    return dictEq;
};
var arbitraryPitch = function (dictArbitrary) {
    return dictArbitrary;
};
var writeImplPitch = function (dict) {
    return dict.writeImplPitch;
};
var writeForeignPitch = function (dictWriteForeignPitch) {
    var writeImplPitch1 = writeImplPitch(dictWriteForeignPitch);
    return {
        writeImpl: function (v) {
            return writeImplPitch1(v);
        }
    };
};
var unison = function (dictInterval) {
    return Data_Monoid.mempty((dictInterval.Group0()).Monoid0());
};
var toPitch = function (dictInterval) {
    return Pitch;
};
var toMidiPitch = function (dict) {
    return dict.toMidiPitch;
};
var toMidiPitch1 = function (dictToMidiPitch) {
    var toMidiPitch2 = toMidiPitch(dictToMidiPitch);
    return {
        toMidi: function (v) {
            return toMidiPitch2(v);
        }
    };
};
var toMidi = function (dict) {
    return dict.toMidi;
};
var toInterval = function (dictInterval) {
    return function (v) {
        return v;
    };
};
var showPitchNotation = function (dict) {
    return dict.showPitchNotation;
};
var showPitch = function (dictNotationPitch) {
    var showPitchNotation1 = showPitchNotation(dictNotationPitch);
    return {
        show: function (v) {
            return showPitchNotation1(v);
        }
    };
};
var showNotation = function (dict) {
    return dict.showNotation;
};
var readImplPitch = function (dict) {
    return dict.readImplPitch;
};
var readForeignPitch = function (dictReadForeignPitch) {
    var readImplPitch1 = readImplPitch(dictReadForeignPitch);
    return {
        readImpl: function (f) {
            return readImplPitch1(f);
        }
    };
};
var pplusi = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    return function (v) {
        return function (b) {
            return append(v)(b);
        };
    };
};
var parsePitchNotation = function (dict) {
    return dict.parsePitchNotation;
};
var notationPitch = function (dictNotationPitch) {
    var showPitchNotation1 = showPitchNotation(dictNotationPitch);
    return {
        parseNotation: (function () {
            var $163 = map(Pitch);
            var $164 = parsePitchNotation(dictNotationPitch);
            return function ($165) {
                return $163($164($165));
            };
        })(),
        showNotation: function (v) {
            return showPitchNotation1(v);
        }
    };
};
var parseNotation = function (dict) {
    return dict.parseNotation;
};
var octave = function (dict) {
    return dict.octave;
};
var major = function (dictInterval) {
    var unison1 = unison(dictInterval);
    return function (v) {
        return v(unison1);
    };
};
var itimes = function (dictInterval) {
    return Data_Group.power(dictInterval.Group0());
};
var timesi = function (dictInterval) {
    return Data_Function.flip(itimes(dictInterval));
};
var isStep = function (dict) {
    return dict.isStep;
};
var iplusp = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    return function (a) {
        return function (v) {
            return append(a)(v);
        };
    };
};
var iplus = function (dictInterval) {
    return Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
};
var ic = function (dict) {
    return dict.ic;
};
var pc = function (dictHasIntervalClass) {
    return map1(ic(dictHasIntervalClass));
};
var emb = function (dict) {
    return dict.emb;
};
var oct = function (dictHasInterval) {
    var Interval0 = dictHasInterval.Interval0();
    var append = Data_Semigroup.append(((Interval0.Group0()).Monoid0()).Semigroup0());
    var emb1 = emb(dictHasInterval);
    var itimes1 = itimes(Interval0);
    var octave1 = octave(Interval0);
    return function (octs) {
        return function (ic1) {
            return append(emb1(ic1))(itimes1(octave1)(octs));
        };
    };
};
var down = function (dictInterval) {
    return Data_Group.ginverse(dictInterval.Group0());
};
var iminus = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    var down1 = down(dictInterval);
    return function (a) {
        return function (b) {
            return append(a)(down1(b));
        };
    };
};
var pfrom = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    var down1 = down(dictInterval);
    return function (v) {
        return function (v1) {
            return append(v)(down1(v1));
        };
    };
};
var pminusi = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    var down1 = down(dictInterval);
    return function (v) {
        return function (b) {
            return append(v)(down1(b));
        };
    };
};
var pto = function (dictInterval) {
    var append = Data_Semigroup.append(((dictInterval.Group0()).Monoid0()).Semigroup0());
    var down1 = down(dictInterval);
    return function (v) {
        return function (v1) {
            return append(v1)(down1(v));
        };
    };
};
var direction = function (dict) {
    return dict.direction;
};
var iabs = function (dictInterval) {
    var direction1 = direction(dictInterval);
    var down1 = down(dictInterval);
    return function (i) {
        if (eq(direction1(i))(Data_Ordering.LT.value)) {
            return down1(i);
        };
        if (Data_Boolean.otherwise) {
            return i;
        };
        throw new Error("Failed pattern match at Data.Pitches.Class (line 168, column 1 - line 168, column 39): " + [ i.constructor.name ]);
    };
};
var chromaticSemitone = function (dict) {
    return dict.chromaticSemitone;
};
var dim = function (dictChromatic) {
    var iminus1 = iminus(dictChromatic.Interval0());
    var chromaticSemitone1 = chromaticSemitone(dictChromatic);
    return function (v) {
        return iminus1(v)(chromaticSemitone1);
    };
};
var minor = function (dictChromatic) {
    var chromaticSemitone1 = chromaticSemitone(dictChromatic);
    return function (v) {
        return v(chromaticSemitone1);
    };
};
var aug = function (dictChromatic) {
    var iplus1 = iplus(dictChromatic.Interval0());
    var chromaticSemitone1 = chromaticSemitone(dictChromatic);
    return function (v) {
        return iplus1(v)(chromaticSemitone1);
    };
};
export {
    octave,
    direction,
    iabs,
    unison,
    oct,
    down,
    iplus,
    iminus,
    itimes,
    timesi,
    emb,
    ic,
    pc,
    isStep,
    chromaticSemitone,
    toMidi,
    parseNotation,
    showNotation,
    Impf,
    minor,
    major,
    dim,
    aug,
    Pitch,
    toPitch,
    toInterval,
    pto,
    pfrom,
    iplusp,
    pplusi,
    pminusi,
    parsePitchNotation,
    showPitchNotation,
    toMidiPitch,
    writeImplPitch,
    readImplPitch,
    eqPitch,
    ordPitch,
    arbitraryPitch,
    functorPitch,
    genericPitch_,
    showPitch,
    notationPitch,
    toMidiPitch1,
    writeForeignPitch,
    readForeignPitch
};
